/*
  "Setovi sa poklonom" - dugme dodaje ceo set (komponente + poklon)
  u korpu jednim pozivom /cart/add.js, pa otvara cart drawer.
  Poklon mora da bude u korpi da bi automatski Buy X Get Y popust
  iz admina legao - zato ide zajedno sa setom, tema nista ne racuna.
*/
(() => {
  class GiftDealCard extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.gift-deal__add');
      this.message = this.querySelector('.gift-deal__msg');
      if (!this.button || this.button.disabled) return;
      this.button.addEventListener('click', () => this.addSet());
    }

    async addSet() {
      let items;
      try {
        items = JSON.parse(this.dataset.items);
      } catch (error) {
        return;
      }
      this.button.disabled = true;
      this.button.classList.add('is-loading');
      this.hideMessage();
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble' }),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections) {
          drawer.renderContents(data);
        } else {
          window.location.href = '/cart';
          return;
        }
        this.button.classList.add('is-added');
        setTimeout(() => this.button.classList.remove('is-added'), 1500);
      } catch (error) {
        const errorMsg =
          this.closest('[data-error-msg]')?.dataset.errorMsg ||
          'Neki proizvod iz seta trenutno nije dostupan. Probaj ponovo malo kasnije.';
        this.showMessage(errorMsg);
      } finally {
        this.button.disabled = false;
        this.button.classList.remove('is-loading');
      }
    }

    showMessage(text) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.hidden = false;
    }

    hideMessage() {
      if (!this.message) return;
      this.message.hidden = true;
    }
  }

  if (!customElements.get('gift-deal-card')) {
    customElements.define('gift-deal-card', GiftDealCard);
  }
})();
